import types from '../types.js';

export const setNotifications = payload => {
  return { type: types.LOAD_NOTIFICATIONS, payload };
};

export const getNotifications = state => {
  return state.notificationReducer.notifications;
};
